"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserShieldSolid: function() {
        return UserShieldSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserShieldSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H15.1468C13.7635 21.523 13 19.4686 13 17.3979L13 16.1671C13.0001 14.5103 14.3432 13.1667 16 13.1667H16.375C16.4733 13.1667 16.5325 13.1489 16.5765 13.1291C16.5834 13.126 16.591 13.1224 16.5993 13.1181C15.2224 12.4037 13.6583 12 12 12Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M19.7284 14.3149C19.5394 14.114 19.2758 14 19 14C18.7241 14 18.4605 14.1139 18.2715 14.3149C17.7383 14.8818 17.1032 15.1667 16.375 15.1667H16C15.4478 15.1667 15.0001 15.6149 15 16.1672L15 17.3979C15 19.9614 16.4815 22.2756 18.7076 22.9563C18.8982 23.0146 19.1018 23.0146 19.2924 22.9563C21.5185 22.2756 23 19.9614 23 17.3979V16.1667C23 15.6144 22.5515 15.1667 21.9992 15.1667H21.625C20.8969 15.1667 20.2616 14.8818 19.7284 14.3149Z",
            fill: "currentColor"
        })
    ]
}), "UserShieldSolid");
const _default = UserShieldSolid;
